import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import ViewAnnexurePartList from './ViewAnnexurePartList';

export default function LoadFromAnnexure(props: any) {

    const [open, setOpen] = React.useState(false);
    const [selectedAnnexure, setselectedAnnexure] = React.useState(false);

    return <>

        <span className={`${props.isQueue || props.orderQueued ? 'cursor-none mr-2' : 'cursor-pointer mr-2'}`} onClick={() => {
            if (props.isQueue || props.orderQueued) {
            } else {
                setOpen(true)
            }
        }}>
            <IconButton className="mr-1 searchbarOptions" size="small" disabled={props.isQueue || props.orderQueued}>
                <FavoriteBorderIcon fontSize="inherit" />
                <span className="font-size-13 load-from-fav ml-1">Load from Annexure/Core Products </span>
            </IconButton>
        </span>

        <Dialog
            open={open}
            onClose={() => { setselectedAnnexure(false); setOpen(false) }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth={true}
            maxWidth="lg"
            PaperProps={{
                style: {
                    height: '650px', // Set your desired height here
                    display: 'flex',
                    flexDirection: 'column'
                }
            }}
        >
            <ViewAnnexurePartList setselectedAnnexure={setselectedAnnexure} setOpen={setOpen} commonInsertionLogic={props.commonInsertionLogic} brandPricingTier={props.brandPricingTier} />
        </Dialog>
    </>
}
